import { getCategoryDataById, getProductByCategoryId, getProductByCategoryIdAndFilteredValue, getProductById, getProductByPartNumbers, getStoreDataByDirectory } from "@/data/hcl/sdk/index";
import { WPLink, WPLinks_COLORE, WPLinks_SIZE, WPLinks_VARIANTE } from "@/data/wp/operations/queries/fragments/link";
import { performanceLog, performanceStart } from "@/utils/performance";
import { buildPageUrl, PageType } from '@/utils/router';
import { getLastParamString, ServerSideParams } from "@/utils/slug";
import { getTopCategoryIdFosnova } from "@/utils/storeInfo";
import getT from "next-translate/getT";
import placeholderCategory from '@/public/placeholder-category.svg';
import { AngleImage, FilterSliderData, ProductImageSlide } from "@/types/common";
import { WPImage } from "@/data/wp/operations/queries/fragments/image";


interface NewSkuAttributes {
  cablaggio : any,
  siglaCablaggio : any,
  lunghezza : any,
  larghezza : any,
  diametro : any,
  paloAltezzaFuoriTerra: any,
  paloAltezzaInterrata: any,
  paloLunghezzaTotale: any,
  peso : any,
  correnteNominaleDriver: any,
  led : string | any | null,
  aperturaFascio: any,
  gradiAsimmetria: any,
  wTot : any,
  potenza:  any,
  colore : any,
  garanzia : any,
  download: any
}{};

interface CatgroupList {
  [key: string] : string
}{};

interface Link {
  links: WPLink[]
}

export const isSliderAttribute = (identifier: any)=>{
    const allowedAttributes = [
    'att_Efficienza',
    'att_EfficienzaLuminosa',
    'att_FlussoLuminosoDefinitivo',
    'att_FlussoLuminosoUscenteCal',
    'att_PotenzaTotApparecchio',
    'att_Diametro',
    'att_Larghezza',
    'att_Lunghezza',
    'att_Altezza'
  ];
   if (!identifier) return false;
  const key = identifier.substring(5);
  return allowedAttributes.includes(key);
}

//Estrae e concatena tutti i valori stringa da un attributo multiplo (es. colore, lunghezza, diametro, ecc.) presente all’interno di `newAttrs`
export const extractAttrValues = (newAttrs: Record<string, any>, key: string, fallback: string | null = null): string | null => {
    const attr = newAttrs?.[key];
      if (!Array.isArray(attr) || attr.length === 0) return fallback;
    const values = attr.flatMap((a: { values?: { value: string }[] }) =>a?.values?.map((v: { value: string }) => v.value) || []).filter(Boolean);
      return values.length > 0 ? values.join(', ') : fallback;
};

export const getStoreDataByStoreName = async (directory: string) => {
  let langId = directory.split('|')[1];
  let storeName = directory.split('|')[0];
  const t0 = performanceStart();
  let {data, errors} = await getStoreDataByDirectory(process.env.NEXT_PUBLIC_DEFAULT_STOREID,storeName);
  //Object.defineProperties(data, {storeFindByStoreNameAndUsage: {resultList: data.storeFindByStoreNameAndUsage.resultList, writable: true}});
  data = Object.assign({}, data,{selected:false});
  performanceLog(t0, `getStoreDataByStoreName -> getStoreDataByDirectory()`, {storeName});
  let storeData = data?.storeFindByStoreNameAndUsage?.resultList[0];
  if(storeData && storeData.defaultLanguageId) {
    data.langId = langId;
  }
  return {data, errors};
}

export const getProductDataByCategoryId = async (dataParams: ServerSideParams) => {

  const nuLocale = dataParams?.locale;
  const params = dataParams?.params;
  const storeId = dataParams?.storeId;
  const langId = dataParams?.langId;
  const catalogId = dataParams?.catalogId;
  const categoryId = dataParams?.categoryId;
  const orderBy = dataParams?.orderBy;
  const t = dataParams?.translate;
  const pageNumber = '1';
  const pageSize = '12';

  const data: any = {};

  data.catalogId = catalogId;
  data.locale = nuLocale;

  let category = await getCategoryDataById(storeId,langId,categoryId);
  let categoryData = category?.data?.categoryViewFindCategoryByUniqueId?.catalogGroupView[0];
  data.categoryData = {
    name: categoryData?.name,
    fullImage: categoryData?.fullImage,
    shortDescription: categoryData?.shortDescription,
    longDescription: categoryData?.longDescription
  }

  data._breadcrumbs = [];
  data._breadcrumbs = getPLPBreadcrumbs(params, data.categoryData);
  data._products = [];
  data._facets = [];
  data._activeFilters = [];
  data._filterNames = [];
  data.recordSetTotal = 0;
  data.recordSetCount = 0;
  let _data: any = {
    _dataNotLoaded: true
  }
  let queryParams = {
    storeId: storeId,
    langId: langId,
    categoryId: categoryId,
    pageNumber: pageNumber,
    pageSize: pageSize,
    orderBy: orderBy
  }
  _data = await getProductByCategoryId(queryParams);
  if(_data && _data._dataNotLoaded !== true && _data?.data?.productViewFindProductsByCategory?.recordSetTotal > 0) {
      data.recordSetTotal = _data?.data?.productViewFindProductsByCategory?.recordSetTotal;
      data.recordSetCount = _data?.data?.productViewFindProductsByCategory?.recordSetCount;
      data._products = await Promise.all(_data?.data?.productViewFindProductsByCategory?.catalogEntryView?.map(mapProductItemToCardList.bind(null,storeId, categoryId,params, '', '')));

      // Genera data._facetViewNormalized dall'array data.productViewFindProductsByCategory.facetView
      // modificando in particolare l'item avente value==='parentCatgroup_id_search'.
      // In quel caso sostituire value con l'id estratto dal primo elemento dell'array item.entry.
      // Questo serve per gestire correttamente la faccetta "Gamma prodotti".
      data._facetViewNormalized = _data?.data?.productViewFindProductsByCategory?.facetView?.map((item: any) => {
        if (item?.value === 'parentCatgroup_id_search') {
          return {
            ...item,
            value: extractFacetIdFromFirstEntry(item),
          };
        }
        return item;
      }) || [];

      let facetList = data._facetViewNormalized || [];

      facetList.forEach(async (item: any) => {
        let facet : any = {
            accordionTitle: "",
            accordionCheckbox: []
        }
        let sliderList : any[] = [];
        let sliderValues : any[] = [];
        let sliderAccordionTitle : string;
        let sliderData : FilterSliderData = {
          valueMin: 0,
          valueMax: 100,
          label: 'W',
          marks: [],
          marksValues: [],
          isReset: false,
          facetId: item?.value,
        }
        if (item?.extendedData?.srchattridentifier?.includes('_cat.att_GammaProdotti')){
          facet.accordionTitle = t('category-filter-title');
        } else if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
          facet.accordionTitle = item?.name;
        }
        let entries = item?.entry;
        entries.forEach(async (entry : any) => {
          let newEntry: any = {};
          if (item?.extendedData?.srchattridentifier?.includes('_cat.att_GammaProdotti')){

            // DISANOJAM-660: added info about family / subfamily
            newEntry = JSON.parse(entry.extendedData.parentIds);

            // normalizzo i dati
            newEntry.label = newEntry.label.replace('&nbsp;','');
            newEntry.value = decodeURIComponent(newEntry.value);
            newEntry?.children?.forEach((child: any) => {
              child.label = child.label.replace('&nbsp;','');
              child.value = decodeURIComponent(child.value);
            });

            // let keyVal = item?.value + ':' + newEntry.value;
            // categoryList[keyVal] = entry.label.replace('&nbsp;','');

            // aggiungo i dati di famiglia ed eventuale sottofamiglia tra le checkbox della faccetta "Gamma prodotti"
            facet.accordionCheckbox.push(newEntry);
          } else if (isSliderAttribute( item?.extendedData?.srchattridentifier)) {
            sliderList.push({
              value: Number(entry.label.split(' ')[0]),
              valueForQuery: decodeURIComponent(entry.value)
            });
            sliderValues.push(parseInt(entry.label.split(' ')[0]));
          } else if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
            newEntry = {
              label: entry.label.replace('&nbsp;',''),
              value: decodeURIComponent(entry.value)
            };
            facet.accordionCheckbox.push(newEntry);
          }
        });
        if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
          if (item?.extendedData?.srchattridentifier?.includes('_cat.att_GammaProdotti')){
            const facetId = extractFacetIdFromFirstEntry(item);
            data?._filterNames.push(facetId);
          } else {
            data?._filterNames.push(item?.value);
          }
          //slider
          if(sliderList.length > 0) {
            sliderAccordionTitle = item?.name;
            sliderData.valueMin = Math.min(...sliderValues);
            sliderData.valueMax = Math.max(...sliderValues);
            const splittedValueForQuery = sliderList[0].valueForQuery.replace(/"/g, '').split('+');
            if (splittedValueForQuery.length === 2) {
              sliderData.label = splittedValueForQuery[1];
            }
            sliderData.label = item?.extendedData?.srchattridentifier?.substring(5) === 'att_Diametro' ? 'mm' : sliderData.label;
            sliderData.marksValues = sliderValues.sort((a,b) => a < b ? -1 : 1);
            sliderData.marks = sliderList.sort((a,b) => a.value < b.value ? -1 : 1);
            data?._facets.push({
              accordionTitle: sliderAccordionTitle,
              accordionSlider: sliderData
            });
          } else {
            facet.accordionCheckbox.sort((a:any, b:any) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));

            //checkbox
            if(!Number.isNaN(facet.accordionCheckbox[0].label.split(' ')[0])){
              // ordino numericamente
              facet.accordionCheckbox.sort((a: any,b: any) => Number(a.label.split(' ')[0]) < Number(b.label.split(' ')[0]) ? -1 : 1)
            }

            data?._facets.push(facet);
          }
        }
      });
      data.langId = langId;
  } else {
    _data = {
      _dataNotLoaded: true
    }
  }
  return {data};
}

export const getFilteredValuesByCategoryId = async (queryParams: any) => {
  const t = await getT(queryParams.locale, 'common');
  let sliderFilter: any[] = [];
  let activeFilters : string = queryParams?.facetList.toString();
  console.log('getFilteredValuesByCategoryId - activeFilters', activeFilters);
  let activeFilterList = queryParams?.facetList;
  console.log('getFilteredValuesByCategoryId - activeFilterList', activeFilterList);
  let activeFiltersForQuery : string = "";
  if(activeFilterList.length > 0){
    activeFiltersForQuery = await getActiveFiltersForQuery(queryParams.facetList, queryParams.filterNames);
  }
  console.log('getFilteredValuesByCategoryId - activeFiltersForQuery', activeFiltersForQuery);
  let categoryList: CatgroupList = {};
  let { data, errors } = await getProductByCategoryIdAndFilteredValue(queryParams.storeId, queryParams.langId, queryParams.categoryId, activeFiltersForQuery, queryParams.orderBy, queryParams?.pageNumber,queryParams?.pageSize);
  data = Object.assign({}, data, {selected:false})
  data._breadcrumbs = [];

  // Recupera i dati della categoria per i breadcrumbs
  let category = await getCategoryDataById(queryParams.storeId, queryParams.langId, queryParams.categoryId);
  let categoryData = category?.data?.categoryViewFindCategoryByUniqueId?.catalogGroupView[0];
  const categoryDataForBreadcrumbs = {
    name: categoryData?.name
  };

  data._breadcrumbs = getPLPBreadcrumbs(queryParams.params, categoryDataForBreadcrumbs);
  data._products = [];
  data._facets = [];
  data.recordSetTotal = 0;
  data.recordSetCount = 0;
  data.recordSetTotal = data?.productViewFindProductsByCategory?.recordSetTotal;
  data.recordSetCount = data?.productViewFindProductsByCategory?.recordSetCount;
  data._products = await Promise.all(data?.productViewFindProductsByCategory?.catalogEntryView?.map(mapProductItemToCardList.bind(null,queryParams.storeId, queryParams.categoryId,queryParams.params, '', '')));

  // Genera data._facetViewNormalized dall'array data.productViewFindProductsByCategory.facetView
  // modificando in particolare l'item avente value==='parentCatgroup_id_search'.
  // In quel caso sostituisce value con l'id estratto dal primo elemento dell'array item.entry.
  // Questo serve per gestire correttamente la faccetta "Gamma prodotti".
  data._facetViewNormalized = data?.productViewFindProductsByCategory?.facetView?.map((item: any) => {
    if (item?.value === 'parentCatgroup_id_search') {
      return {
        ...item,
        value: extractFacetIdFromFirstEntry(item),
      };
    }
    return item;
  }) || [];

  let facetList = data._facetViewNormalized;
  console.log('getFilteredValuesByCategoryId - facetList', facetList);

  facetList?.forEach(async (item: any) => {
    let facet : any = {
      accordionTitle: "",
      accordionCheckbox: []
    }
    let sliderList : any[] = [];
    let sliderValues : any[] = [];
    let sliderAccordionTitle: string = "";
    let accordionSliderData: FilterSliderData = {
      valueMin: 0,
      valueMax: 100,
      label: 'W',
      marks: [],
      marksValues: [],
      isReset: false,
      facetId: item?.value,
    };
    if (item?.extendedData?.srchattridentifier?.includes('_cat.att_GammaProdotti')){
      facet.accordionTitle = t('category-filter-title');
    } else if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
      facet.accordionTitle = item?.name;
    }
    let entries = item?.entry;
    entries.forEach(async (entry : any) => {
      let newEntry: any = {};
      if (item?.extendedData?.srchattridentifier?.includes('_cat.att_GammaProdotti')){

        // DISANOJAM-660: estraggo le informazioni relative a famiglia e sottofamiglia
        newEntry = JSON.parse(entry.extendedData.parentIds);

        // normalizzo i dati e aggiungo le voci alla lista delle categorie poi usata per i filtri attivi
        newEntry.label = newEntry.label.replace('&nbsp;','');
        newEntry.value = decodeURIComponent(newEntry.value);
        newEntry?.children?.forEach((child: any) => {
          child.label = child.label.replace('&nbsp;','');
          child.value = decodeURIComponent(child.value);
          categoryList[child.value] = child.label.replace('&nbsp;','');
        });
        categoryList[newEntry?.value] = newEntry.label.replace('&nbsp;','');

        // aggiungo i dati di famiglia ed eventuale sottofamiglia tra le checkbox della faccetta "Gamma prodotti"
        facet.accordionCheckbox.push(newEntry);

      } else if (isSliderAttribute( item?.extendedData?.srchattridentifier)) {
        sliderList.push({
          value: Number(entry.label.split(' ')[0]),
          valueForQuery: decodeURIComponent(entry.value)
        });

        sliderValues.push(parseInt(entry.label.split(' ')[0]));

        if(!sliderFilter.includes(item?.value)){
          sliderFilter.push(item?.value);
        }
      } else if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
        newEntry = {
          label: entry.label.replace('&nbsp;',''),
          value: decodeURIComponent(entry.value)
        };
        facet.accordionCheckbox.push(newEntry);
      }
    });
    if(!item?.extendedData?.srchattridentifier?.substring(5).includes('OfferPrice')){
      //slider
      if(sliderList.length > 0) {
        sliderAccordionTitle = item?.name;
        accordionSliderData.valueMin = Math.min(...sliderValues);
        accordionSliderData.valueMax = Math.max(...sliderValues);
        const splittedValueForQuery = sliderList[0].valueForQuery.replace(/"/g, '').split('+');
        if (splittedValueForQuery.length === 2) {
          accordionSliderData.label = splittedValueForQuery[1];
        }
        accordionSliderData.label = item?.extendedData?.srchattridentifier?.substring(5) === 'att_Diametro' ? 'mm' : accordionSliderData.label;
        accordionSliderData.marksValues = sliderValues.sort((a,b) => a < b ? -1 : 1);
        accordionSliderData.marks = sliderList.sort((a,b) => a.value < b.value ? -1 : 1);

        // MODIFICATO: Recupera il valore specifico per questo facet dall'oggetto sliderValues
        const facetId = item?.value;
        if (queryParams?.sliderValues && queryParams.sliderValues[facetId]) {
          accordionSliderData.sliderCurrentValue = queryParams.sliderValues[facetId];
          accordionSliderData.isReset = false;
        } else if (queryParams?.sliderFilterValueDeleted === true && queryParams?.facetId === null) {
          // Reset generale di tutti gli slider
          accordionSliderData.isReset = true;
          accordionSliderData.sliderCurrentValue = undefined;
        } else if (queryParams?.sliderFilterValueDeleted === true && queryParams?.facetId === facetId) {
          // Reset solo se è stato cancellato specificamente questo slider
          accordionSliderData.isReset = true;
          accordionSliderData.sliderCurrentValue = undefined;
        } else if (queryParams?.resetSlider === true && queryParams?.facetId === facetId) {
          // AGGIUNTO: Reset esplicito quando viene rimosso il chip
          accordionSliderData.isReset = true;
          accordionSliderData.sliderCurrentValue = undefined;
        } else {
          accordionSliderData.isReset = false;
          accordionSliderData.sliderCurrentValue = undefined;
        }

        data?._facets.push({
          accordionTitle: sliderAccordionTitle,
          accordionSlider: accordionSliderData
        });
      } else {

        facet.accordionCheckbox.sort((a:any, b:any) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0));
        if(!Number.isNaN(facet.accordionCheckbox[0].label.split(' ')[0])){
          facet.accordionCheckbox.sort((a: any,b: any) => Number(a.label.split(' ')[0]) < Number(b.label.split(' ')[0]) ? -1 : 1)
        }

        data?._facets.push(facet);
      }
    }
  });

  if (activeFilters && activeFilters !== '') {
    data._activeFilters = [];
    // Set per tenere traccia dei filtri checkbox già processati
    const processedCheckboxFilters = new Set<string>();

    facetList?.forEach((item: any) => {
      const identifier = item?.extendedData?.srchattridentifier;
      const isSlider = isSliderAttribute(identifier);
      const facetId = item?.value;

      let aggregatedSliderFilter: any = null;
      let aggregatedNames: string[] = [];
      let numericValues: number[] = [];
      // MODIFICATO: Determina l'unità di misura specifica per questo slider
      let unitOfMeasure = 'W'; // default

    activeFilters.split(',').forEach((filterValueRaw: string) => {
      //console.log('getFilteredValuesByCategoryId - activeFilters.split', filterValueRaw, item?.value);
      if (filterValueRaw.includes(item?.value)) {
        if (filterValueRaw.includes('mm')) unitOfMeasure = 'mm';

        const filterValue = filterValueRaw.trim();

        const parsedValue = parseFloat(
          getActiveFilterValue(filterValue).replace(/[^\d.,-]/g, '')
        );

          if (isSlider) {
            // MODIFICATO: Controlla l'unità di misura dal primo valore di questo slider
            if (!aggregatedSliderFilter) {
              // Determina l'unità di misura dall'etichetta dello slider stesso
              if (item?.extendedData?.srchattridentifier?.substring(5) === 'att_Diametro') {
                unitOfMeasure = 'mm';
              } else {
                // Altrimenti prova a estrarla dal valore del filtro
                if (filterValueRaw.includes('mm')) {
                  unitOfMeasure = 'mm';
                } else {
                  // Oppure dal primo mark dello slider (se disponibile)
                  const entries = item?.entry;
                  if (entries && entries.length > 0) {
                    const firstLabel = entries[0].label;
                    const parts = firstLabel.split(' ');
                    if (parts.length > 1) {
                      unitOfMeasure = parts[1];
                    }
                  }
                }
              }

              aggregatedSliderFilter = {
                name: [],
                values: [],
                displayValue: undefined,
                displayValueUnit: unitOfMeasure,
                facetId: facetId
              };
            }

            aggregatedNames.push(filterValue);
            if (!isNaN(parsedValue)) numericValues.push(parsedValue);

            return;
          }

          // NON SLIDER - CHECKBOX
          // Aggiungi solo se non è già stato processato
          if (!processedCheckboxFilters.has(filterValue)) {
            processedCheckboxFilters.add(filterValue);
            let activeFilterInfo = {};
            if (item?.extendedData?.srchattridentifier?.substring(5) === 'att_GammaProdotti') {
            // if (item?.value === 'parentCatgroup_id_search') {
              activeFilterInfo = {
                name: filterValue,
                value: categoryList[filterValue]
              };
              console.log('getFilteredValuesByCategoryId - filterValue (att_GammaProdotti)', activeFilterInfo);
            } else {
              activeFilterInfo = {
                name: filterValue,
                value: getActiveFilterValue(filterValue)
              };
              console.log('getFilteredValuesByCategoryId - filterValue (default)', activeFilterInfo);
            }
            data._activeFilters.push(activeFilterInfo);
          }
        }
      });

      if (aggregatedSliderFilter) {
        const uniqueNames = aggregatedNames.filter((v, i, a) => a.indexOf(v) === i);
        const uniqueNumbers = numericValues.filter((v, i, a) => a.indexOf(v) === i);

        const min = Math.min(...uniqueNumbers);
        const max = Math.max(...uniqueNumbers);

        aggregatedSliderFilter.values = [min, max];
        aggregatedSliderFilter.name = uniqueNames;

        // Usa il valore specifico di questo slider dai sliderValues
        if (queryParams?.sliderValues && queryParams.sliderValues[facetId]) {
          aggregatedSliderFilter.displayValue = queryParams.sliderValues[facetId];
        } else {
          aggregatedSliderFilter.displayValue = [min, max];
        }

        data._activeFilters.push(aggregatedSliderFilter);
      }
    });
  }

  return { data, errors };
}

const getActiveFilterValue = (filterValue: string): any => {
  return filterValue.split(':')[1]?.replaceAll("\"", "").replaceAll('+',' ');
}


/**
 * Estrae dal primo elemento di item.entry dentro .value il segmento prima di ":"
 * Caso particolare di faccetta per famiglia e sottofamiglia (ex Gamma prodotti)
 * modifico l'identificativo dinamicamente altrimenti quando l'utente interagisce con il filtro
 * non ci sarà un match tra i suoi sottovalori e l'identificativo di faccetta
 *
 * @param facet oggetto faccetta
 */
const extractFacetIdFromFirstEntry = (facet: any): string => {
  if (Array.isArray(facet?.entry) && facet.entry.length > 0 && facet.entry[0]?.value) {
    const decodedValue = decodeURIComponent(facet.entry[0].value);
    return decodedValue.split(':')[0];
  } else {
    // Attenziona: questo valore è solo un fallback perchè potrebbe cambiare a seconda dell'ambiente del catalogo
    return 'ads_f21018_ntk_cs';
  }
}

/**
 * Usage degli attachment HCL che veicolano le immagini alternative (angle images) di un prodotto.
 * Il tracciato e' quello concordato tra PIM e HCL: una riga per ogni immagine alternativa con
 * usage ANGLEIMAGES_FULLIMAGE, piu' l'eventuale miniatura corrispondente con usage ANGLEIMAGES_THUMBNAIL.
 */
export const ANGLE_IMAGE_FULL_USAGE = 'ANGLEIMAGES_FULLIMAGE';
export const ANGLE_IMAGE_THUMBNAIL_USAGE = 'ANGLEIMAGES_THUMBNAIL';

export const isAngleImageAttachment = (usage: string | undefined | null): boolean => {
  return usage === ANGLE_IMAGE_FULL_USAGE || usage === ANGLE_IMAGE_THUMBNAIL_USAGE;
}

/**
 * Estrae dagli attachment del prodotto le immagini alternative da mostrare nello slider di PDP.
 * Le thumbnail sono opzionali: se HCL non le valorizza si usa l'immagine full anche per l'anteprima.
 * L'ordine e' quello restituito da HCL (l'attachment non espone il campo sequence).
 *
 * @param attachments lista attachments del catalogEntryView di prodotto
 * @returns lista di immagini alternative normalizzate
 */
export const getAngleImages = (attachments: any[] | undefined | null): AngleImage[] => {
  if (!Array.isArray(attachments)) {
    return [];
  }
  const fullImages = attachments.filter((item: any) => item?.usage === ANGLE_IMAGE_FULL_USAGE && item?.attachmentAssetPath);
  const thumbnails = attachments.filter((item: any) => item?.usage === ANGLE_IMAGE_THUMBNAIL_USAGE && item?.attachmentAssetPath);

  return fullImages.map((item: any, index: number) => {
    const thumbnail = thumbnails[index];
    return {
      fullImage: normalizeAzureAssetUrl(item.attachmentAssetPath, ''),
      thumbnail: normalizeAzureAssetUrl((thumbnail || item).attachmentAssetPath, ''),
      altText: item.longdesc || item.name || ''
    };
  });
}

/**
 * Costruisce le slide dello slider immagini di PDP: immagine principale seguita dalle immagini alternative.
 *
 * @param mainImage immagine principale (fullImage del prodotto o dello sku)
 * @param angleImages immagini alternative del prodotto padre
 * @param altText testo alternativo dell'immagine principale
 * @returns slide compatibili con il componente ProductDetailImage
 */
export const buildProductImageSlides = (mainImage: string | null | undefined, angleImages: AngleImage[] | undefined | null, altText: string = ''): ProductImageSlide[] => {
  const buildImage = (id: string, url: string | null, alt: string): WPImage => ({
    id: id,
    mimeType: 'image/webp',
    mediaItemUrl: url as string,
    altText: alt,
    mediaDetails: { width: 636, height: 636 }
  });

  const slides: ProductImageSlide[] = [];

  if (mainImage) {
    slides.push({ backgroundImage: buildImage('pdp-image', mainImage, altText) });
  }

  (angleImages || []).forEach((angleImage: AngleImage, index: number) => {
    if (!angleImage?.fullImage) {
      return;
    }
    slides.push({
      backgroundImage: buildImage(`pdp-image-angle-${index}`, angleImage.fullImage, angleImage.altText || altText),
      thumbnailImage: angleImage.thumbnail && angleImage.thumbnail !== angleImage.fullImage
        ? buildImage(`pdp-thumb-angle-${index}`, angleImage.thumbnail, angleImage.altText || altText)
        : undefined
    });
  });

  // nessuna immagine disponibile: si restituisce comunque una slide "vuota" per far scattare il placeholder del componente
  if (slides.length === 0) {
    slides.push({ backgroundImage: buildImage('pdp-image', null, altText) });
  }

  return slides;
}

export const getProductDataById = async (dataParams: ServerSideParams) => {

  const nuLocale = dataParams?.locale;
  const params = dataParams?.params;
  const storeId = dataParams?.storeId;
  const langId = dataParams?.langId;
  const productId = dataParams?.productId;
  const categoryId = dataParams?.categoryId;
  const t = dataParams.translate;
  //const hostname = dataParams.hostname;
  const rootCategorySlug = 'cat';
  let brandSlug = '';
  let categoryIdSlug = '';
  let productIdSlug = '';
  if (params?.brand) {
    brandSlug = rootCategorySlug + "/" + getLastParamString(params?.brand);
  }
  if (params?.category && params?.brand) {
    categoryIdSlug = brandSlug + "/" + getLastParamString(params?.category);
  }
  if (params?.product && params?.category) {
    productIdSlug = categoryIdSlug + "/" + getLastParamString(params?.product);
  }

  params['slug'] = t('garanzie-slug');

  const data: any = {};

  data.product = {};
  data.attachments = [];
  data.angleImages = [];
  data.productImageSlides = [];
  data.dimensioniImg = '';
  data.iconList = [];
  data.descriptionList = [];
  data.singleTable = [];
  data.versionsSkuRows = [];
  data.merchandisingAssociationsRows = [];
  data.relatedProducts = [];
  data.breadcrumbs = [];
  let familyPartNumbers: string[] = [];

  let category = await getCategoryDataById(storeId,langId,categoryId);
  let categoryData = category?.data?.categoryViewFindCategoryByUniqueId.catalogGroupView[0];

  let _data: any = {
    _dataNotLoaded: true
  }
  _data = await getProductById(storeId,langId,productId);
  if(_data && _data._dataNotLoaded !== true && _data?.data?.productViewFindProductById?.catalogEntryView.length > 0) {
    let product = _data?.data?.productViewFindProductById?.catalogEntryView[0];
    data.product = product;

    let brandBreadcrumb = getBreadcrumbLinks(brandSlug,params?.brand,true, false);

    let categoryBreadcrumb = getBreadcrumbLinks(categoryIdSlug,categoryData?.name, false, true);

    let productBreadcrumb = getBreadcrumbLinks(productIdSlug,product?.shortDescription.replaceAll('&nbsp;',' '), false, false);

    data.breadcrumbs = [brandBreadcrumb, categoryBreadcrumb, productBreadcrumb];

    let icons = product.attachments?.filter((item: { usage: string; }) => item.usage.includes('Pittogrammi'));
    icons?.forEach(async (icon: any) => {
        let iconObj = {
          icon:  normalizeAzureAssetUrl(icon.attachmentAssetPath, ''),
          iconTooltip: icon.longdesc
        }
        data.iconList.push(iconObj);
    });

    debugger;
    let attributes = product?.attributes;
    data.tipoMont = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_TipoMont');
    data.colore = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_ColoreCorpo');
    data.ottica = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_OtticaDesc');
    data.montaggio = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Montaggio');
    data.normative = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_UgrDesc');
    data.appUso = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_LuogoInstallazione');
    data.lunghezza = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Lunghezza');
    data.larghezza = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Larghezza');
    data.altezza = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Altezza');
    data.diametro = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Diametro');
    data.dimIncasso = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Diametro');
    data.paloAltezzaFuoriTerra = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloAltezzaFuoriTerra');
    data.paloAltezzaInterrata = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloAltezzaInterrata');
    data.paloLunghezzaTotale = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloLunghezzaTotale');
    data.dimensionsAttr = ['att_Lunghezza','att_Larghezza','att_Altezza','att_Diametro'];
    data.dimensions = {
      att_Lunghezza: attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Lunghezza'),
      att_Larghezza: attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Larghezza'),
      att_Altezza: attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Altezza'),
      att_Diametro: attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Diametro')
    }

    //ATTACHMENTS
     let attachments = data?.product?.attachments;
     attachments?.forEach((item: any) => {
       // le angle images alimentano lo slider di PDP (vedi sotto), non la sezione download
       if(item.identifier && item.identifier !== '' && !item.usage.includes('Pittogrammi') && !isAngleImageAttachment(item.usage)) {
        if(item.usage === 'DisegnoTecnicoJPG'){
          data.dimensioniImg = item.attachmentAssetPath;
        } else if(item.usage === 'ZipTutti'){
          data.downloadZip.push(item);
        } else {
          data.attachments.push(item);
        }
       }
     });

    //IMMAGINI MULTIPLE (angle images)
    data.angleImages = getAngleImages(attachments);
    data.productImageSlides = buildProductImageSlides(product?.fullImage, data.angleImages, product?.shortDescription?.replaceAll('&nbsp;',' '));

    data.productDetailInfo = {
      desc: []
    };
    if(data?.colore[0]?.name !== undefined && data?.colore[0]?.values[0].value !== undefined){
      data?.productDetailInfo?.desc.push({
        name: data?.colore[0]?.name,
        value: data?.colore[0]?.values[0].value
      });
    }
    if(data?.ottica[0]?.name !== undefined && data?.ottica[0]?.values[0].value !== undefined){
      data?.productDetailInfo?.desc.push({
        name: data?.ottica[0]?.name,
        value: data?.ottica[0]?.values[0].value
      });
    }
    if(data?.montaggio[0]?.name !== undefined && data?.montaggio[0]?.values[0].value !== undefined){
      data?.productDetailInfo?.desc.push({
        name: data?.montaggio[0]?.name,
        value: data?.montaggio[0]?.values[0].value
      });
    }

    //VERSIONI
    const showGaranzia = false;
    let sKUs = product?.sKUs;
    let skuTableTitleFull = {
      codice: t('codice-th-title'),
      cablaggio: t('cablaggio-th-title'),
      siglaCablaggio: t('siglaCablaggio-th-title'),
      peso: t('peso-th-title'),
      correnteNominaleDriver: t('correnteNominaleDriver-th-title'),
      lumen: t('lumen-output-th-title'),
      gradiAsimmetria: t('gradiAsimmetria-th-title'),
      aperturaFascio: t('aperturaFascio-th-title'),
      wTot: t('watt-tot-th-title'),
      potenza: t('potenza-th-title'),
      colore: t('colore-th-title'),
      lunghezza: t('lunghezza-th-title'),
      larghezza: t('larghezza-th-title'),
      diametro: t('diametro-th-title'),
      paloAltezzaFuoriTerra: t('palo-altezza-fuori-terra-th-title'),
      paloAltezzaInterrata: t('palo-altezza-interrata-th-title'),
      paloLunghezzaTotale: t('palo-lunghezza-totale-th-title'),
      garanzia: t('garanzia-th-title'),
      download: t('download-th-title')
    };
    let skuTableTitleDelta = [];
    let tableAttrs: NewSkuAttributes = {
      cablaggio: '',
      siglaCablaggio: '',
      colore: '',
      garanzia: '',
      correnteNominaleDriver: '',
      gradiAsimmetria: '',
      potenza: '',
      led: '',
      aperturaFascio: '',
      peso: '',
      wTot: '',
      lunghezza : '',
      larghezza : '',
      diametro : '',
      paloAltezzaFuoriTerra: '',
      paloAltezzaInterrata: '',
      paloLunghezzaTotale: '',
      download: ''
    };
    let tableAttrsColList: NewSkuAttributes = {
      cablaggio: [],
      siglaCablaggio: [],
      colore: [],
      garanzia: [],
      correnteNominaleDriver: [],
      gradiAsimmetria: [],
      potenza: [],
      led: [],
      aperturaFascio: [],
      peso: [],
      wTot: [],
      lunghezza : [],
      larghezza : [],
      diametro : [],
      paloAltezzaFuoriTerra: [],
      paloAltezzaInterrata: [],
      paloLunghezzaTotale: [],
      download: []
    };
    sKUs?.forEach((sku: any) => {
      let skuAttributes = sku?.attributes;
      // let attributes = integrateResponse(sku).attributes;
      /* let att_FlussoUscentePreliminare = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_FlussoUscentePreliminare');
      let att_FlussoLuminosoDefinitivo = attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_FlussoLuminosoDefinitivo'); */
      let att_FlussoLuminosoUscenteCal = skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_FlussoLuminosoUscenteCal');
      let att_Cct = skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Cct');
      let att_CriMkt = product?.attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_CriMkt');
      let att_CriMktItem = skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_CriMkt');
      if (att_CriMktItem.length > 0){ att_CriMkt = att_CriMktItem; }
      // console.log(product);

      /**
       * Check if is undefined or not
       *
       * @param newAttrs
       * @returns
       */
      const hasGetWTot = function(newAttrs: any){
        if  (newAttrs?.wTot[0]?.length === 0)
          { return false; }
        if (typeof newAttrs?.wTot[0]?.values[0] === 'undefined')
          { return false; }
        if (typeof newAttrs?.wTot[0]?.values[0]?.value === 'undefined' || newAttrs?.wTot[0]?.values[0]?.value === '0 W')
          { return false; }

        return true;
      }

      debugger;
      const newAttrs : NewSkuAttributes = {
        cablaggio : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Cablaggio'),
        siglaCablaggio : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_SiglaCablaggio'),
        peso : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Peso'),
        correnteNominaleDriver : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_CorrenteNominaleDriver'),
        led : getLumenOutputKCri(att_FlussoLuminosoUscenteCal[0]?.values[0].value,att_Cct[0]?.values[0].value,att_CriMkt[0]?.values[0].value),
        aperturaFascio : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_AperturaFascio'),
        gradiAsimmetria : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_GradiAsimmetria'),
        wTot : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PotenzaTotApparecchio'),
        colore : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_ColoreCorpo'),
        potenza : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Potenza'),
        lunghezza : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Lunghezza'),
        larghezza : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Larghezza'),
        diametro : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_Diametro'),
        paloAltezzaFuoriTerra : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloAltezzaFuoriTerra'),
        paloAltezzaInterrata : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloAltezzaInterrata'),
        paloLunghezzaTotale : skuAttributes?.filter((item: { identifier: string; }) => item.identifier === 'att_PaloLunghezzaTotale'),
        garanzia: buildPageUrl(PageType.PAGE, params, nuLocale),
        download: normalizeAzureAssetUrl(data.downloadZip, '/')
      };


      // fallback su valore del prodotto padre se l'attributo non è presente a livello di item
      if (newAttrs.colore.length === 0) {
        newAttrs.colore = data?.colore;
      }
      if (newAttrs.aperturaFascio.length === 0) {
        newAttrs.aperturaFascio = product.attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_AperturaFascio');
      }
      if (newAttrs.lunghezza.length === 0) {
        newAttrs.lunghezza = data.lunghezza;
      }
      if (newAttrs.larghezza.length === 0) {
        newAttrs.larghezza = data.larghezza;
      }
      if (newAttrs.diametro.length === 0) {
        newAttrs.diametro = data.diametro;
      }
      if (newAttrs.paloAltezzaFuoriTerra.length === 0) {
        newAttrs.paloAltezzaFuoriTerra = data.paloAltezzaFuoriTerra;
      }
      if (newAttrs.paloAltezzaInterrata.length === 0) {
        newAttrs.paloAltezzaInterrata = data.paloAltezzaInterrata;
      }
      if (newAttrs.paloLunghezzaTotale.length === 0) {
        newAttrs.paloLunghezzaTotale = data.paloLunghezzaTotale;
      }

      tableAttrsColList['cablaggio'].push(newAttrs?.cablaggio[0]?.values[0].value || null)
      tableAttrsColList['siglaCablaggio'].push(newAttrs?.siglaCablaggio[0]?.values[0].value || null)
      tableAttrsColList['peso'].push(newAttrs?.peso[0]?.values[0].value || null)
      tableAttrsColList['correnteNominaleDriver'].push(newAttrs?.correnteNominaleDriver[0]?.values[0].value || null)
      tableAttrsColList['led'].push(newAttrs?.led === ' ' ? null : newAttrs?.led)
      tableAttrsColList['aperturaFascio'].push(newAttrs?.aperturaFascio[0]?.values[0].value || null)
      tableAttrsColList['gradiAsimmetria'].push(newAttrs?.gradiAsimmetria[0]?.values[0].value || null)
      tableAttrsColList['wTot'].push( hasGetWTot(newAttrs) === false ? null : newAttrs?.wTot[0]?.values[0].value)
      tableAttrsColList['potenza'].push(newAttrs?.potenza[0]?.values[0].value || null)
      tableAttrsColList['colore'].push(extractAttrValues(newAttrs, 'colore', null));
      tableAttrsColList['lunghezza'].push(newAttrs?.lunghezza[0]?.values[0].value || null)
      tableAttrsColList['larghezza'].push(newAttrs?.larghezza[0]?.values[0].value || null)
      tableAttrsColList['diametro'].push(newAttrs?.diametro[0]?.values[0].value || null)
      tableAttrsColList['paloAltezzaFuoriTerra'].push(newAttrs?.paloAltezzaFuoriTerra[0]?.values[0].value || null)
      tableAttrsColList['paloAltezzaInterrata'].push(newAttrs?.paloAltezzaInterrata[0]?.values[0].value || null)
      tableAttrsColList['paloLunghezzaTotale'].push(newAttrs?.paloLunghezzaTotale[0]?.values[0].value || null)

      tableAttrs = newAttrs;

      let tableRow = {
        sku: sku?.partNumber,
        openModalLabel: sku?.partNumber,
        storeId: storeId,
        langId: langId,
        breadcrumbs: data.breadcrumbs,
        attachments: data.attachments,
        parentProductName: data.product.shortDescription,
        fullImage: data.product.fullImage,
        appUso: data?.appUso[0]?.values[0].value || ' ',
        thumbnail: data.product.thumbnail,
        angleImages: data.angleImages,
        cablaggio: newAttrs?.cablaggio[0]?.values[0].value || ' ',
        siglaCablaggio: newAttrs?.siglaCablaggio[0]?.values[0].value || ' ',
        kg: newAttrs?.peso[0]?.values[0].value || ' ',
        correnteNominaleDriver: newAttrs?.correnteNominaleDriver[0]?.values[0].value || ' ',
        gradiAsimmetria: newAttrs?.gradiAsimmetria[0]?.values[0].value || ' ',
        potenza:  newAttrs?.potenza[0]?.values[0].value || ' ',
        lumen: newAttrs?.led,
        aperturaFascio: newAttrs?.aperturaFascio[0]?.values[0].value || ' ',
        wtot: hasGetWTot(newAttrs) === false ? ' ' : newAttrs?.wTot[0]?.values[0].value,
        colore: extractAttrValues(newAttrs, 'colore', ' '),
        lunghezza: newAttrs?.lunghezza[0]?.values[0].value || ' ',
        larghezza: newAttrs?.larghezza[0]?.values[0].value || ' ',
        diametro: newAttrs?.diametro[0]?.values[0].value || ' ',
        paloAltezzaFuoriTerra: newAttrs?.paloAltezzaFuoriTerra[0]?.values[0].value || ' ',
        paloAltezzaInterrata: newAttrs?.paloAltezzaInterrata[0]?.values[0].value || ' ',
        paloLunghezzaTotale: newAttrs?.paloLunghezzaTotale[0]?.values[0].value || ' ',
        garanzia: newAttrs.garanzia || null,
        download: process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true' ? (newAttrs.download || null) : null
      }
      data?.versionsSkuRows.push(tableRow);
    });

    const allEqual = (arr: any[],param : string | null) => arr.every(val => val === param);

    let activeColumns : NewSkuAttributes = {
      cablaggio: false,
      siglaCablaggio: false,
      colore: false,
      garanzia: false,
      correnteNominaleDriver: false,
      gradiAsimmetria: false,
      potenza: false,
      led: false,
      aperturaFascio: false,
      peso: false,
      wTot: false,
      larghezza : false,
      lunghezza : false,
      diametro : false,
      paloAltezzaFuoriTerra : false,
      paloAltezzaInterrata : false,
      paloLunghezzaTotale : false,
      download: false
    };
    skuTableTitleDelta.push(skuTableTitleFull.codice);
    /*
    if(!allEqual(tableAttrsColList['cablaggio'], null)){
      activeColumns['cablaggio'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.cablaggio);
    }
    */
    if(!allEqual(tableAttrsColList['siglaCablaggio'],null)){
      activeColumns['siglaCablaggio'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.siglaCablaggio);
    }
    if(!allEqual(tableAttrsColList['peso'],null)){
      activeColumns['peso'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.peso);
    }
    if(!allEqual(tableAttrsColList['correnteNominaleDriver'],null)){
      activeColumns['correnteNominaleDriver'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.correnteNominaleDriver);
    }
    if(!allEqual(tableAttrsColList['led'],null)){
      activeColumns['led'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.lumen);
    }
    if(!allEqual(tableAttrsColList['aperturaFascio'],null)){
      activeColumns['aperturaFascio'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.aperturaFascio);
    }
    if(!allEqual(tableAttrsColList['gradiAsimmetria'],null)){
      activeColumns['gradiAsimmetria'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.gradiAsimmetria);
    }
    if(!allEqual(tableAttrsColList['wTot'],null)){
      activeColumns['wTot'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.wTot);
    }
    if(!allEqual(tableAttrsColList['potenza'],null)){
      activeColumns['potenza'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.potenza);
    }
    if(!allEqual(tableAttrsColList['colore'],null)){
      activeColumns['colore'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.colore);
    }
    if(!allEqual(tableAttrsColList['lunghezza'],null)){
      activeColumns['lunghezza'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.lunghezza);
    }
    if(!allEqual(tableAttrsColList['larghezza'],null)){
      activeColumns['larghezza'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.larghezza);
    }
    if(!allEqual(tableAttrsColList['diametro'],null)){
      activeColumns['diametro'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.diametro);
    }
    if(!allEqual(tableAttrsColList['paloAltezzaFuoriTerra'],null)){
      activeColumns['paloAltezzaFuoriTerra'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.paloAltezzaFuoriTerra);
    }
    if(!allEqual(tableAttrsColList['paloAltezzaInterrata'],null)){
      activeColumns['paloAltezzaInterrata'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.paloAltezzaInterrata);
    }
    if(!allEqual(tableAttrsColList['paloLunghezzaTotale'],null)){
      activeColumns['paloLunghezzaTotale'] = true;
      skuTableTitleDelta.push(skuTableTitleFull.paloLunghezzaTotale);
    }
    if (showGaranzia) {
      skuTableTitleDelta.push(skuTableTitleFull.garanzia);
    }
    if(process.env.NEXT_PUBLIC_ENABLE_ZIP === 'true' && tableAttrs?.download){
      skuTableTitleDelta.push(skuTableTitleFull.download);
    }

    data.versionsTable = {
      tabTitle: t('versions-tab-title'),
      tableInfo: {
        th: skuTableTitleDelta,
        tr: data?.versionsSkuRows,
        activeColumns: activeColumns
      }
    };


    // ACCESSORI/PRODOTTI CORRELATI:
    // - ACCESSORY va in tabella accessori
    // - X-SELL alimenta la CardList dei prodotti correlati
    const merchandisingAssociations = product?.merchandisingAssociations ?? [];
    if (merchandisingAssociations.length > 0) {
      const accessoryAssociations = merchandisingAssociations.filter((item: any) => item?.associationType === 'ACCESSORY');
      familyPartNumbers = Array.from(
        new Set(
          merchandisingAssociations
            .filter((item: any) => item?.associationType === 'X-SELL')
            .map((item: any) => item?.partNumber)
            .filter((partNumber: string | undefined) => Boolean(partNumber))
        )
      ) as string[];

      if (accessoryAssociations.length > 0) {
        data.merchandisingAssociationsRows = await Promise.all(accessoryAssociations.map(mapMerchAssoc.bind(null, storeId, langId, nuLocale, params)));
        data.accessoryTable = {
          tabTitle: t('accessory-tab-title'),
          tableInfo: {
            th: ["", t('name-th-title'), t('desc-th-title')],
            tr: data?.merchandisingAssociationsRows
          }
        };
      }
    }

    //DIMENSIONI
    data.dimensionsRow = [];

    data?.dimensionsAttr?.forEach((attribute: any) => {
      if(data.dimensions[attribute].length > 0) {
        data.dimensionsRow.push({
          name: data.dimensions[attribute][0].name,
          value: data.dimensions[attribute][0]?.values[0]?.value
        });
      }
    });

    data.dimensionsTable = {
      tabTitle: t('dimension-tab-title'),
      dimensioniImg: { id: "product-detail-dimension", mimeType: "image/webp", mediaItemUrl: data?.dimensioniImg, mediaDetails: { width: 502, height: 502 } },
      dimensioniTable: data.dimensionsRow
    };
  } else {
    _data = {
      _dataNotLoaded: true
    }
  }

  if(data.versionsSkuRows?.length > 0){
    data.singleTable.push(data.versionsTable);
  }
  if(data.merchandisingAssociationsRows?.length > 0){
    data.singleTable.push(data.accessoryTable);
  }
  data.singleTable?.push(data.dimensionsTable);

  let _dataRelatedProductList: any = {
    _dataNotLoaded : true
  };
  if(familyPartNumbers && familyPartNumbers.length > 0) {
    const partNumbers = familyPartNumbers.slice(0,5);
    _dataRelatedProductList = await getProductByPartNumbers(storeId,langId,partNumbers);
    if(_dataRelatedProductList && _dataRelatedProductList._dataNotLoaded !== true){
      console.log('data.relatedProducts', _dataRelatedProductList?.data?.productViewFindProductByPartNumbers?.catalogEntryView);
      data.relatedProducts = await Promise.all(_dataRelatedProductList?.data?.productViewFindProductByPartNumbers?.catalogEntryView?.map(mapProductItemToCardList.bind(null,storeId, '',params,'',langId)));
    }
  }

  return {data};
}

/**
 * Dato un item contenente i dati di prodotto (catalogEntryView) nel formato restituito da HCL,
 * estrae l'id di categoria da utilizzare per costruire l'url di dettaglio prodotto in caso non sia presente nei parametri di url.
 * L'id di categoria viene estratto dall'attributo att_GammaProdotti o, in fallback, dal parentCatalogGroupID.
 * Nel caso di att_GammaProdotti, viene considerato il segmento dopo "#".
 * Se il segmento dopo "#" contiene "@", viene considerato solo il segmento prima di "@".
 * Questo affinche, per costruire l'url di dettaglio prodotto, venga usato il codice della famiglia (primo segmento dopo il "#")
 * e venga ignorato un eventuale codice di sottofamiglia (segmento dopo "@").
 * Altrimenti il breadcrumb in PDP riporterebbe erroneamente la famiglia ("Rodio") invece della categoria padre ("Proiettori").
 * Esempio:
 *  Disano  >   Proiettori  >   Rodio   >   Micro Rodio LED
 *    |             |              |              |
 *  Brand   >   Categoria   >   Famiglia >  Sottofamiglia
 */
export const getProductUrlCategoryIdFromItem = (item: any): string => {
  if (!item) {
    return '';
  }

  const gammaAttr = item?.attributes?.find((attribute: any) => attribute?.identifier === 'att_GammaProdotti');
  const gammaValue = gammaAttr?.values?.[0]?.value;

  if (typeof gammaValue === 'string' && gammaValue.includes('#')) {
    const afterHash = gammaValue.split('#')[1] || '';
    if (afterHash.includes('@')) {
      return afterHash.split('@')[0];
    }
    return afterHash;
  }

  return item?.parentCatalogGroupID?.[1]?.split('_')[1] ?? '';
};

/**
 * Dato un item contenente i dati di prodotto (catalogEntryView) nel formato restituito da HCL,
 * effettua il mapping restituendo un oggetto da passare al componente WhiteCard o, sottoforma di array, CardList.
 *
 * Usage example:
 *  const cardListProducts = data?.productViewFindProductsByCategory?.catalogEntryView?.map(mapProductItemToCardList);
 */
export const mapProductItemToCardList = async (storeId: string, categoryId: string, params: any, locale: string, langId: string, item: any) => {
  // Detail url
  if(params === undefined){
    params = {};
  }
  params['product'] = cleanProductUrlParam(item?.uniqueID + '-' + item?.shortDescription);
  let detailUrl = '';
  if(categoryId && categoryId !== ''){
    detailUrl = buildPageUrl(PageType.PDP, params);
  }else{
    const categoryIdFromItem = getProductUrlCategoryIdFromItem(item);
    detailUrl = await getProductUrl(categoryIdFromItem, item?.uniqueID, item?.shortDescription, storeId, langId, locale, params);
  }

  // Image
  // TODO: dinamicizzare le info dell'immagine anteprima del prodotto (es: label and img)
  const image = { id: 'card-image', mimeType: 'image/webp', mediaItemUrl: item.thumbnail ? item.thumbnail : null, mediaDetails: { width: 255, height: 255 } };

  return {
    url: detailUrl,
    //label: "Novita",
    img: image,
    title: item?.shortDescription,
    storeId: storeId,
    categoryId: categoryId
  };
}

export const cleanProductUrlParam = (urlComponent: string) => {
  let cleaned = urlComponent;
  cleaned = cleaned.replaceAll('&nbsp;',' ');
  // cleaned = sanitize(cleaned);
  // remove url reserved chars: \n \r ␣ ! " # $ % & ' ( ) * + , : ; = ? @ [ ] . < > \ ^ ` { | } ~ £ 円
  cleaned = urlComponent.replaceAll(/[\n\r␣!"#\$%&'\(\)\*\+,:;=\?@\[\].<>\\\^`{\|}~£円]/g, '');
  // remove other weird chars: ø ° ≤ ≥
  cleaned = cleaned.replaceAll(/[ø°≤≥]/g, '');
  // sostituisce con il trattino qualsiasi carattere diverso da numeri e lettere (considerando anche alfabeti diversi dal latino).
  cleaned = cleaned.replaceAll(/[^\p{L}\p{N}]/gu, '-').toLowerCase();
  return cleaned;
}

const mapMerchAssoc = async (storeId: string, langId: string, nuLocale: string, params: any, merchandisingAssociation: any) => {
  return {
    immagine: { id: "product-detail-accessori-1", mimeType: "image/webp", mediaItemUrl: merchandisingAssociation?.thumbnail ? merchandisingAssociation?.thumbnail : placeholderCategory, mediaDetails: { width: 87, height: 87 } },
    sku: merchandisingAssociation?.partNumber,
    merchUrl: await getProductUrl(merchandisingAssociation.parentCatalogGroupID[1].split('_')[1], merchandisingAssociation?.uniqueID, merchandisingAssociation?.shortDescription, storeId, langId, nuLocale, params),
    nome: merchandisingAssociation?.shortDescription,
    descrizione: merchandisingAssociation?.shortDescription,
    associationType: merchandisingAssociation?.associationType
  };
}

const getActiveFiltersForQuery = async (activeFilterList: string[], facetIds: string[]) => {
let activeFiltersForQuery: string = "";
let activeFiltersForQueryList: string[] = [];
if(activeFilterList.length > 0) {
    facetIds.forEach((facetId : string) => {
      let tmpSameValList = [];
      tmpSameValList = activeFilterList.filter((activeFilter : string) => activeFilter.includes(facetId));
      if(tmpSameValList.length > 1) {
        activeFiltersForQueryList.push('(' + tmpSameValList.join(' OR ') + ')');
      } else if(tmpSameValList.length === 1) {
        activeFiltersForQueryList.push(tmpSameValList.toString());
      }
    });
    if(activeFiltersForQueryList.length > 1) {
      activeFiltersForQuery = activeFiltersForQueryList.map(filter => `(${filter})`).join(' AND ');
    } else if(activeFiltersForQueryList.length === 1){
      activeFiltersForQuery = `${activeFiltersForQueryList.toString()}`;
    }
}
return activeFiltersForQuery;
}

const getBreadcrumbLinks = (slug: string, name: string, isRoot: boolean, disableClientSideNavigation: boolean = false) => {
  let linkObj : Link = {
    links : []
  };
  let breadcrumbLink : WPLink = {
    __typename: "DefaultTemplate_Fasce_Fasce_Showroom-List_Links_LinkInterno",
      linkInterno: {
        id: '',
        slug: slug,
        uri: "/" + slug + "/",
        title: slug
      },
      label: isRoot === true ? name.toUpperCase() : name,
      target: null,
      variante: WPLinks_VARIANTE.plainLink,
      colore: WPLinks_COLORE.primary,
      dimensione: WPLinks_SIZE.large,
      disableClientSideNavigation: disableClientSideNavigation,
    }
    linkObj.links.push(breadcrumbLink);
  return linkObj;
}

const getPLPBreadcrumbs = (params: any, categoryData: any) => {
  const rootCategorySlug = 'cat';
  const breadcrumbs: any[] = [];

  // Brand breadcrumb (se presente nei params)
  if (params?.brand) {
    const brandSlug = rootCategorySlug + "/" + getLastParamString(params.brand);
    const brandName = getLastParamString(params.brand);
    breadcrumbs.push(getBreadcrumbLinks(brandSlug, brandName, true, false));
  }

  // Category breadcrumb (se presente nei params e categoryData)
  if (params?.category && categoryData?.name) {
    const brandSlug = params?.brand ? rootCategorySlug + "/" + getLastParamString(params.brand) : rootCategorySlug;
    const categoryIdSlug = brandSlug + "/" + getLastParamString(params.category);
    breadcrumbs.push(getBreadcrumbLinks(categoryIdSlug, categoryData.name, false, true));
  }

  return breadcrumbs;
}

export const getTechnicalDataAttributeKey = () => {
  return [
  // INFORMAZIONI GENERALI
  // DIMENSIONI_E_PESO
  // INSTALLAZIONE
  // CARATTERISTICHE_ELETTRICHE_E_CONTROLLI
  // DATI_FOTOMETRICI
  // CARATTERISTICHE_MECCANICHE
  // MATERIALI_E_COLORI
  // EMERGENZA
  // NORME_E_CONFORMITA
  // DOTAZIONI
  // GARANZIA

  'att_Produttore', 'att_CodiceBreveProdotto', 'att_CodiceOrdine', 'att_CodiceUnivocoEuropeo',
  'att_NomeArtic', 'att_NomeDesigner', 'att_CorpoDesc', 'att_AttaccoPalo', 'att_Base', 'att_ColoreCorpo',
  'att_Diffusore', 'att_OtticaDesc', 'att_TipoDiDistribuzioneFotometrica',
  'att_Calpestabile', 'att_Calpestabile', 'att_Ugr', 'att_UgrDesc', 'att_Verniciatura', 'att_Verniciatura2', 'att_VerniciaturaSpeciale',
  'att_Dissipatore', 'att_SuperficieEspostaVentoFrontale', 'att_SuperficieEspostaVentoLaterale', 'att_SiglaCablaggio', 'att_Cablaggio',
  'att_TipoDiVoltaggio', 'att_TensioneMin', 'att_TensioneMax', 'att_Tensione', 'att_FrequenzaNominale', 'att_FrequenzaMin', 'att_FrequenzaMax', 'att_Sensori',
  'att_Controllo','att_TecnologiaSensoreCal', 'att_InterfacciaCal', 'att_FunzioniIntegrateCal', 'att_RegIndipendLuceDirettaIndiretta',
  'att_LowFlicker', 'att_AperturaFascio', 'att_GradiAsimmetria', 'att_FattoreDiPotenza', 'att_SurgeComune',
  'att_SurgeDifferenziale', 'att_CapElettricaMaxFase', 'att_CaricoMax', 'att_EquipagDotaz', 'att_CollegamentoPresaSpinaIncluso',
  'att_ARichiesta', 'att_LunghezzaCavo', 'att_NomeLampada', 'att_CorrenteNominaleDriver', 'att_FlussoLuminosoUscenteCal', 'att_FlussoLuminosoUscenteLineare',
  'att_PotenzaLampMetro', 'att_NumLedMetro', 'att_PotenzaMax', 'att_PotenzaMin', 'att_PotenzaTotApparecchio', 'att_PPE', 'att_PPF',
  'att_TemperaturaAmbiente', 'att_Cct', 'att_HclTwCctMax', 'att_HclTwCctMin', 'att_CctMkt', 'att_CriMkt', 'att_ConsistenzaCromaticaCal',
  'att_Efficienza', 'att_EfficienzaLuminosa', 'att_TempAmbieMax', 'att_TempAmbieMin', 'att_LumenMaintenance', 'att_FailureRate', 'att_LedRatedLife',
  'att_LedRatedLifeUV', 'att_RischioFotobiologico', 'att_Normativa',  'att_TestDiLaboratorio', 'att_Marcature', 'att_RegisteredDesign', 'att_TestResistenzaFiloACaldo',
  'att_ClasseIsolamentoElettrico', 'att_Ip', 'att_IpParteOttica', 'att_IpVanoAccessori', 'att_Ik', 'att_Altezza', 'att_Larghezza', 'att_Lunghezza', 'att_Diametro',
  'att_DiametroFinale', 'att_Peso', 'att_DiametroMax', 'att_DiametroMin', 'att_PaloAltezzaFuoriTerra', 'att_PaloAltezzaInterrata', 'att_PaloLunghezzaTotale', 'att_DimensioniCodolo',
  'att_DimensInstallaziLarghezza', 'att_DimensInstallaziLunghezza', 'att_DimensInstalDiametroIncasso', 'att_DimInstallaziDiametroIncassoMax', 'att_DimInstallaziDiametroIncassoMin',
  'att_Warnings', 'att_Garanzia', 
  'att_CampoRilevamento', 'att_AlimentazionePerEmergenza', 'att_EmergenzaSA-SE', 'att_LivelloEmergenza', 'att_DurataBatteria', 'att_ZonaAtex', 'att_ClasseTemperaturaAtex', 'att_EtichettaEnergeticaLed'];
};
 
export const getTechnicalDataAttributeValue = (attributeKeys: string[], attributes: any) => {
  let technicalDataMap: any = {};
  attributeKeys.forEach(elem => {
    if(attributes?.filter((item: { identifier: string; }) => item.identifier === elem) !== undefined){
      technicalDataMap[elem] = attributes?.filter((item: { identifier: string; }) => item.identifier === elem);
      if(elem === 'att_FattoreDiPotenza'){
        technicalDataMap['att_SegnoFattorePotenza'] = (attributes?.filter((item: { identifier: string; }) => item.identifier === 'att_SegnoFattorePotenza'));
      }
    }
  });

  // Se compilate att_TensioneMin e att_TensioneMax, non pubblicare att_Tensione. Se non presenti, pubblicare att_Tensione.
  // Ovviamente deve essere anche attiva la cancellazione del dato dal sito, in caso cambino gli attributi compilati in PIM
  if (
      technicalDataMap['att_TensioneMin'] && technicalDataMap['att_TensioneMin'].length > 0 &&
      technicalDataMap['att_TensioneMax'] && technicalDataMap['att_TensioneMax'].length > 0 &&
      technicalDataMap['att_Tensione'] && technicalDataMap['att_Tensione'].length > 0
    ) {
    technicalDataMap['att_Tensione'] = [];
  }

  return technicalDataMap;
}

const getProductUrl = async (categoryId : string, productId : string, name: string, storeId: string, langId: string, nuLocale: string, params: any) => {
  const localParams = { ...params }; // clone shallow per evitare mutazioni globali
  let parentCategoryId = "";
  let parentCategoryName = "";
  let parentParentCategoryId = '';
  let _dataCategory: any = {
    _dataNotLoaded : true
  };
  let _dataParentCategory: any = {
    _dataNotLoaded : true
  };
  _dataCategory = await getCategoryDataById(storeId,langId,categoryId);
  if(_dataCategory._dataNotLoaded !== true) {
    parentCategoryId = _dataCategory.data?.categoryViewFindCategoryByUniqueId?.catalogGroupView?.[0]?.parentCatalogGroupID;
    if (parentCategoryId) {
      _dataParentCategory = await getCategoryDataById(storeId,langId,parentCategoryId);
      if(_dataParentCategory._dataNotLoaded !== true) {
        parentCategoryName = _dataParentCategory.data?.categoryViewFindCategoryByUniqueId?.catalogGroupView?.[0]?.name?.toLowerCase();
        parentParentCategoryId = _dataParentCategory.data?.categoryViewFindCategoryByUniqueId?.catalogGroupView?.[0]?.parentCatalogGroupID
      }
    }
  }

  if(!localParams['brand']){
    const topCategoryFosnova = getTopCategoryIdFosnova();
    if(parentParentCategoryId === topCategoryFosnova){
      localParams['brand'] = 'fosnova';
    }else{
      localParams['brand'] = 'disano';
    }
  }
  localParams['product'] = cleanProductUrlParam(productId + '-' + name);
  localParams['category'] = cleanProductUrlParam(parentCategoryId + '-' + parentCategoryName);
  let pdpUrl = buildPageUrl(PageType.PDP, localParams, nuLocale);
  return pdpUrl !== undefined ? pdpUrl : '';
}

function getLumenOutputKCri(att_FlussoLuminosoUscenteCal : string | undefined,att_Cct : string | undefined, att_CriMkt : string | undefined): string | null {
  let lumenOutputKCri:string | undefined = '';
  let flussoluminoso = att_FlussoLuminosoUscenteCal + '-';
  if(flussoluminoso.trim() === '-')
    lumenOutputKCri = (!att_Cct ? '': att_Cct) + ' - ' + (!att_CriMkt ? '': att_CriMkt);
  else
    lumenOutputKCri = att_FlussoLuminosoUscenteCal + ' - ' + (!att_Cct ? '': att_Cct) + ' - ' + (!att_CriMkt ? '': att_CriMkt);
    if(lumenOutputKCri.includes('undefined')){
    return ' ';
  }

  return lumenOutputKCri;
}

/**
 * Use the envinroment variabile to build the right url in the FE for azure asset resources
 * @param assetPath
 * @returns
 */
export const normalizeAzureAssetUrl = function (assetPath:string, suffix: string) {
  const hclHostAssetsURL = process.env.NEXT_PUBLIC_HCL_HOST_ASSETS;
  let normalized = '';
  if (hclHostAssetsURL){
    const hclHostAssets = new URL(hclHostAssetsURL).hostname;
    normalized = assetPath?.replace('https://' + hclHostAssets + suffix, '');
  }

  return normalized;
};


